module.exports = __webpack_public_path__ + "img/1.51a3bc08.png";